import eventbus from 'tiny-emitter/instance';
import { BG_START_SCALE_RATE, OPACITY_START_SCALE_RATE, ZOOM } from '@/constants';

export default class DrawingBackgroundImage {
  constructor(app) {
    this.app = app;
    this.setup();
    return this;
  }

  get bgImage() {
    return this.app.bgImage;
  }

  set bgImage(val) {
    this.app.bgImage = val;
  }

  setup() {
    this.addEventHandlers();
  }

  addEventHandlers() {
    eventbus.on('background:add', this.loadBackgroundImage, this);
    eventbus.on('background:resize', this.resizeBackgroundImage, this);
    eventbus.on('background:maketransparent', this.transparentBackgroundImage, this);
    eventbus.on('background:delete', this.deleteBackgroundImage, this);
  }

  removeEventHandlers() {
    eventbus.off('background:add', this.loadBackgroundImage);
    eventbus.off('background:resize', this.resizeBackgroundImage);
    eventbus.off('background:maketransparent', this.transparentBackgroundImage);
    eventbus.off('background:delete', this.deleteBackgroundImage);
  }

  loadBackgroundImage(url, uploaded = false) {
    try {
      if (!this.bgImage || url !== this.bgImage.src) {
        eventbus.emit('background:delete');
        this.bgImage = this.app.svg.image('');
        this.bgImage.on('error', () => {
          eventbus.emit('background:error');
        });
        /*this.bgImage.on('load', () => {
          eventbus.emit('background:loaded', url);
        });*/
        const lthis = this;
        this.bgImage.load(url).loaded(function () {
          lthis.resizeBackgroundImage(BG_START_SCALE_RATE);
          lthis.transparentBackgroundImage(OPACITY_START_SCALE_RATE);
          lthis.centerize();
          lthis.bgImage.draggable();
          lthis.app.bgImage = lthis.bgImage;
          lthis.app.hasBgImage = true;
          if (uploaded) {
            eventbus.emit('background:loaded', url, uploaded);
          } else {
            eventbus.emit('background:loaded', url);
          }
          lthis.bgImage.back();
          eventbus.emit('history:snapshot', 'Background Image added');
        });
      }
    } catch (e) {
      eventbus.emit('background:error');
    }
  }

  centerize() {
    if (!this.bgImage) {
      return;
    }
    this.bgImage.center(0, 0);
  }

  resizeBackgroundImage(newScaleRate) {
    if (!this.bgImage) {
      return;
    }

    newScaleRate *= ZOOM.LEVELS.SECTION;

    this.bgImage.scale(newScaleRate, newScaleRate, 0, 0);
    eventbus.emit('selection:delayedHistory', 'Background Image scale');
  }

  transparentBackgroundImage(opacity) {
    if (!this.bgImage) {
      return;
    }
    opacity = 1 - opacity;
    this.bgImage.opacity(opacity);
    eventbus.emit('selection:delayedHistory', 'Background Image transparency');
  }

  deleteBackgroundImage() {
    if (!this.bgImage) {
      return;
    }
    this.bgImage.remove();
    this.bgImage = null;
    eventbus.emit('history:snapshot', 'Background Image removed');
  }

  destroy() {
    if (this.bgImage) {
      this.bgImage.draggable(false);
    }
    this.removeEventHandlers();
  }
}
